import apps, { AppConfig } from '../config/apps';

export default function getAppConfig(): AppConfig {
  return apps[process.env.APP_ID!];
}
